import { Analytics, EcommerceEvent } from "./types";

export class AdsConversionSourceProvider {
  initilized: boolean = false;
  initialize(client: AdsConversionClient): Analytics {
    if (!this.initilized) {
      const gtagScript = document.createElement("script");
      gtagScript.async = true;
      gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${client.clientId}`;

      const configScript = document.createElement("script");
      configScript.innerHTML = `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', '${client.clientId}');`;

      document.head.appendChild(gtagScript);
      document.head.appendChild(configScript);

      this.initilized = true;
    }
    return AdsConversionAnalytics(client);
  }
}

function AdsConversionAnalytics(client: AdsConversionClient): Analytics {
  return {
    group: () => {},
    register: () => {},
    identify: () => {},
    screen: () => {},
    ecommerceEvent: (event: EcommerceEvent) => {
      switch (event.event) {
        case "Order Completed":
          if (!!client.slot) {
            const conversionEvent = document.createElement("script");
            conversionEvent.innerHTML = `gtag('event', 'conversion', {'send_to': '${client.clientId}/${client.slot}'});`;
            document.head.appendChild(conversionEvent);
          }
          break;
      }
    },
    event: () => {},
  };
}

interface AdsConversionTrackingOptions {
  clientId: string;
  slot?: string;
  sendPageView?: boolean;
}

export interface AdsConversionClient extends AdsConversionTrackingOptions {
  provider: "ads_conversion";
}

export function makeAdsConversionClient(
  clientId: string,
  slot?: string,
  options?: AdsConversionTrackingOptions
): AdsConversionClient {
  return {
    provider: "ads_conversion",
    clientId: clientId,
    slot: slot,
    sendPageView: options?.sendPageView ?? true,
  };
}
